import { createFileRoute } from '@tanstack/react-router';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}/')({
  staticData: {
    path: PAGE_PATHS.VIOLATION_TICKETS,
    key: EntityTypeConfigKeys.ViolationTicket,
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.VIOLATION_TICKETS,
      app: APP_PATHS.ASSETS,
      permission: Permission.READ,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
